import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Case } from '../../api/responses';
import CaseLinks from '../CaseLinks';
import { Tag } from 'antd';
import {
  Line,
  PreviewCaseContainer,
  PreviewText,
  TagsContainer,
  TextContainer,
  Title,
} from './styles';

type TPreviewCase = {
  data: Case;
};
const PreviewCase = ({ data }: TPreviewCase) => {
  const { pathname } = useLocation();

  return (
    <PreviewCaseContainer>
      <TextContainer>
        <Link
          to={pathname === '/' ? `/${data.id}` : `${pathname}/${data.id}`}
          reloadDocument
        >
          <Title>{data.title}</Title>
        </Link>
        <PreviewText>
          {data.text_preview}{' '}
          <Link
            to={pathname === '/' ? `/${data.id}` : `${pathname}/${data.id}`}
            reloadDocument
          >
            Read more
          </Link>
        </PreviewText>
      </TextContainer>
      <CaseLinks author={data.author} editor={data.editor} games={0} />
      <TagsContainer>
        {data.tag_names.map((tag) => (
          <Tag key={tag}>{tag}</Tag>
        ))}
      </TagsContainer>
      <Line />
    </PreviewCaseContainer>
  );
};

export default PreviewCase;
